// extracted by mini-css-extract-plugin
module.exports = {"container":"RecallButton_container__O-sy3","btn":"RecallButton_btn__22JQ5","btnIconWrapper":"RecallButton_btnIconWrapper__1iNZM"};